var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLaboratory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_16585)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.2869 15.5078C12.7945 15.9892 12.249 16.415 11.6605 16.7772L11.7825 16.9627H7.19533L6.51522 17.9884C4.87774 16.9372 3 15.3951 3 12.7363C3 9.71013 5.35823 8.0625 7.96045 6.63672C8.35596 6.85495 8.7552 7.06591 9.1507 7.27687L9.52034 7.46235C8.24902 8.07418 7.05752 8.83504 5.97182 9.72833H13.0614C13.5225 10.1388 13.8989 10.6327 14.1703 11.1832H4.83337C4.60149 11.669 4.4828 12.1996 4.48593 12.7363C4.48217 12.7956 4.48217 12.8552 4.48593 12.9145H3.5877V14.3694H4.85922C5.08034 14.7912 5.36862 15.1755 5.7131 15.5078H13.2869Z",
    fill: "#28ADFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.575 2.58283C14.7766 4.40143 12.9876 5.57989 11.0396 6.63831C10.6478 6.42008 10.2486 6.20912 9.84939 5.99816L9.50195 5.81266C10.293 5.39438 11.0544 4.9761 11.7198 4.53236H14.0485V3.07749H13.4977C13.7866 2.75091 14.0235 2.38298 14.2 1.98633L15.575 2.58283Z",
    fill: "#28ADFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9992 12.737C15.9992 15.3994 14.1104 16.9488 12.4656 18L11.7817 16.9634L11.6597 16.7779C12.2482 16.4157 12.7937 15.9899 13.2861 15.5085C13.6305 15.177 13.9176 14.7925 14.1363 14.3701H3.58695V12.9152H14.5133C14.5171 12.8559 14.5171 12.7963 14.5133 12.737C14.5113 12.1984 14.3849 11.6673 14.1437 11.1839C13.8723 10.6334 13.4958 10.1395 13.0348 9.72903C11.9517 8.83575 10.7627 8.07486 9.49369 7.46304L9.12405 7.27757C8.72855 7.06661 8.32935 6.85565 7.93384 6.63742C6.00066 5.57899 4.19685 4.38963 3.39844 2.58194L4.75131 2C4.92783 2.39665 5.16465 2.76458 5.45362 3.09116H14.0734V4.54603H7.26479C7.9523 4.98977 8.71747 5.40803 9.50849 5.82631L9.85592 6.01181C10.2551 6.22277 10.6544 6.43373 11.0462 6.65196C13.641 8.06319 15.9992 9.71083 15.9992 12.737Z",
    fill: "#28ADFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_16585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 16,
    fill: "white",
    transform: "translate(3 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLaboratory);
export default __webpack_public_path__ + "static/media/IconLaboratory.383647a5a829f79719995df148cbc9ec.svg";
export { ForwardRef as ReactComponent };